/**
 * This file is used to bundle additional translations for the RaiseNow
 * credit card iframe.
 *
 * Since RaiseNow does not support all languages that we need to support
 * we must provide translations
 *
 * RaiseNow does not support all languages that we support, so for some
 * we need do provide the translations ourself.
 */

import {
  RaiseNowCreditCardTranslations,
  RaiseNowCreditCardUpdateTranslationsPayload,
} from '../raisenow.types';
import RaiseNowTranslations_LT from './raisenow-cc.lt.json';

/**
 * We use a slightly different format then the one that RaiseNow
 * expects us to send.
 *
 */
function _prepareTranslation(
  translations: CustomRaiseNowCreditCardLocalization,
): RaiseNowCreditCardTranslations {
  return {
    payment_form: {
      ...translations.payment_form,
      placeholders: {
        cvv: '000',
        cardno: '0000 0000 0000 0000',
        ...translations.payment_form.placeholders,
      },
    },
    epik_errors: {
      ...translations.epik_errors,
    },
    validation_errors: {
      ...translations.validation_errors,
    },
    info_toggle: {
      cc: {
        title: translations.info_toggle.cc.title,
        text_html: `
        <div class="content">
          <p><strong>${translations.info_toggle.cc.subtitle}</strong></p>
          <p>${translations.info_toggle.cc.description}</p>
          <div class="images">
            <div class="image-mastercard"></div>
            <div class="image-visa"></div>
          </div>
        </div>`,
      },
      cvv: {
        title: translations.info_toggle.cvv.title,
        text_html: `
        <div class="content">
          <div class="image-container">
            <div class="image"></div>
          </div>
          <div class="text">
            <p>${translations.info_toggle.cvv.description}</p>
          </div>
        </div>`,
      },
    },
  };
}

/**
 * @param translations Translations to use, defaults to all
 *
 * @returns
 * Custom translations, ready to be passed to the RaiseNow iframe.
 */
export function prepareAdditionalRaiseNowCreditCardTranslations(
  translations: Record<
    string,
    CustomRaiseNowCreditCardLocalization
  > = RAISENOW_CC_ADDITIONAL_TRANSLATIONS,
): RaiseNowCreditCardUpdateTranslationsPayload {
  return Object.entries(translations).reduce(
    (acc, [locale, customTranslations]) => ({
      ...acc,
      [locale]: _prepareTranslation(customTranslations),
    }),
    {} as RaiseNowCreditCardUpdateTranslationsPayload,
  );
}

/**
 * Custom translations for RaiseNows credit card iframe to extend
 * or provide missing translations.
 *
 * @see {@link RaiseNowCreditCardTranslations}
 */
export const RAISENOW_CC_ADDITIONAL_TRANSLATIONS: Record<
  string,
  CustomRaiseNowCreditCardLocalization
> = {
  lt: RaiseNowTranslations_LT,
};
